import { TrackingEvents } from '../../events';
import { sendFullStoryEvent } from '../../fullstory/events';
import { LeaveSessionButton } from './LeaveSessionButton';
import { useLeaveSessionCallback } from './useLeaveSessionCallback';

export function LeaveSessionButtonWrapper() {
  const disconnect = useLeaveSessionCallback();
  return (
    <LeaveSessionButton
      onClick={() => {
        sendFullStoryEvent(TrackingEvents.CLIENT_SESSION_LEAVE);
        disconnect();
      }}
    />
  );
}
